import React from 'react';

import JetLogo from '../JetLogo/JetLogo';

import './Copyright.scss';

const Copyright = () => {
  const { langs } = window;
  return (
    <div className="copyright">
      <div className="copyright__info">
        © 2018 JetStyle. { langs.allRights }
      </div>
      <div className="copyright__logo-wrap">
        <JetLogo color="black" />
      </div>
    </div>
  )
}

export default Copyright;


// WEBPACK FOOTER //
// ./src/components/Copyright/Copyright.js